import React from 'react'
import { Link } from 'react-router-dom'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium'
import Chip from '@mui/material/Chip'
import { TransferOrderStatus } from '../../graphql'
import { TransferOrderRow } from './hooks/useTransferOrdersDataQuery'
import { STATUS_CHIP_COLOR, STATUS_LABEL } from './constants'
import TransferOrderActionsMenu from './components/TransferOrderActionsMenu'
import { formatDateTime } from '../../utils/formatters/date'

const columns: GridColDef[] = [
	{
		field: 'id',
		headerName: 'Transfer Order #',
		width: 140,
		renderCell: ( params: GridRenderCellParams ) => (
			<Link to={`/transfer-orders/${params.value}`}>TO-{params.value}</Link>
		),
	},
	{
		field: 'status',
		headerName: 'Status',
		width: 130,
		renderCell: ( params: GridRenderCellParams ) => {
			const status = params.value as TransferOrderStatus | null | undefined
			// An empty cell beats an empty pill if the field ever comes back null.
			if ( !status ) return null
			return (
				<Chip
					label={STATUS_LABEL[ status ] ?? status}
					color={STATUS_CHIP_COLOR[ status ] ?? 'default'}
				/>
			)
		},
	},
	{
		field: 'transferOrderType',
		headerName: 'Type',
		width: 90,
	},
	{
		field: 'fromStore',
		headerName: 'From Store',
		width: 180,
		valueGetter: ( _value, row ) => ( row as TransferOrderRow ).fromStore?.name ?? '',
	},
	{
		field: 'toStore',
		headerName: 'To Store',
		width: 180,
		valueGetter: ( _value, row ) => ( row as TransferOrderRow ).toStore?.name ?? '',
	},
	{
		field: 'trackingNumber',
		headerName: 'Tracking #',
		width: 160,
		valueGetter: ( _value, row ) => ( row as TransferOrderRow ).trackingNumber ?? '',
	},
	{
		field: 'demandRequest',
		headerName: 'Request',
		width: 140,
		renderCell: ( params: GridRenderCellParams ) => {
			const dr = ( params.row as TransferOrderRow ).demandRequest
			if ( !dr ) return null
			return <Link to={`/requests/${dr.id}`}>REQ-{dr.requestNumber}</Link>
		},
	},
	{
		field: 'requesterNote',
		headerName: 'Requester Note',
		flex: 1,
		minWidth: 150,
		valueGetter: ( _value, row ) => {
			const r = row as TransferOrderRow
			return r.__typename === 'ManualTransferOrder' ? r.requesterNote ?? '' : ''
		},
	},
	{
		field: 'dateCreated',
		headerName: 'Created',
		width: 160,
		valueFormatter: ( value ) => formatDateTime( value ),
	},
	{
		field: 'dateShipped',
		headerName: 'Shipped',
		width: 160,
		valueFormatter: ( value ) => formatDateTime( value ),
	},
	{
		field: 'dateCompleted',
		headerName: 'Completed',
		width: 160,
		valueFormatter: ( value ) => formatDateTime( value ),
	},
	{
		field: 'actions',
		headerName: 'Actions',
		width: 80,
		sortable: false,
		filterable: false,
		renderCell: ( params: GridRenderCellParams ) => (
			<TransferOrderActionsMenu row={params.row as TransferOrderRow} />
		),
	},
]

export default columns
